import type { Recipe } from '../types/recipe';
import { t } from './mockCommon';

function createParmentierRecipe(): Recipe {
  return {
    dish_id: -1,
    prep_time: 25,
    cook_time: 35,
    chill_time: 0,
    equipment: [
      t('onboarding.mockData.recipes.parmentier.equipment.eq1'),
      t('onboarding.mockData.recipes.parmentier.equipment.eq2'),
      t('onboarding.mockData.recipes.parmentier.equipment.eq3'),
      t('onboarding.mockData.recipes.parmentier.equipment.eq4'),
      t('onboarding.mockData.recipes.parmentier.equipment.eq5'),
      t('onboarding.mockData.recipes.parmentier.equipment.eq6'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.parmentier.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.parmentier.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.parmentier.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.parmentier.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.parmentier.steps.step1.instructions.inst4') },
          { id: 5, order: 4, instruction: t('onboarding.mockData.recipes.parmentier.steps.step1.instructions.inst5') },
          { id: 6, order: 5, instruction: t('onboarding.mockData.recipes.parmentier.steps.step1.instructions.inst6') },
          { id: 7, order: 6, instruction: t('onboarding.mockData.recipes.parmentier.steps.step1.instructions.inst7') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.parmentier.steps.step2.name'),
        instructions: [
          { id: 8, order: 0, instruction: t('onboarding.mockData.recipes.parmentier.steps.step2.instructions.inst1') },
          { id: 9, order: 1, instruction: t('onboarding.mockData.recipes.parmentier.steps.step2.instructions.inst2') },
          { id: 10, order: 2, instruction: t('onboarding.mockData.recipes.parmentier.steps.step2.instructions.inst3') },
          { id: 11, order: 3, instruction: t('onboarding.mockData.recipes.parmentier.steps.step2.instructions.inst4') },
          { id: 12, order: 4, instruction: t('onboarding.mockData.recipes.parmentier.steps.step2.instructions.inst5') },
          { id: 13, order: 5, instruction: t('onboarding.mockData.recipes.parmentier.steps.step2.instructions.inst6') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.parmentier.steps.step3.name'),
        instructions: [
          { id: 14, order: 0, instruction: t('onboarding.mockData.recipes.parmentier.steps.step3.instructions.inst1') },
          { id: 15, order: 1, instruction: t('onboarding.mockData.recipes.parmentier.steps.step3.instructions.inst2') },
          { id: 16, order: 2, instruction: t('onboarding.mockData.recipes.parmentier.steps.step3.instructions.inst3') },
          { id: 17, order: 3, instruction: t('onboarding.mockData.recipes.parmentier.steps.step3.instructions.inst4') },
          { id: 18, order: 4, instruction: t('onboarding.mockData.recipes.parmentier.steps.step3.instructions.inst5') },
          { id: 19, order: 5, instruction: t('onboarding.mockData.recipes.parmentier.steps.step3.instructions.inst6') },
        ],
      },
    ],
  };
}

/**
 * Recette : Saumon en croûte (ID -2)
 */
function createSalmonCrustRecipe(): Recipe {
  return {
    dish_id: -2,
    prep_time: 30,
    cook_time: 25,
    chill_time: 10,
    equipment: [
      t('onboarding.mockData.recipes.salmonCrust.equipment.eq1'),
      t('onboarding.mockData.recipes.salmonCrust.equipment.eq2'),
      t('onboarding.mockData.recipes.salmonCrust.equipment.eq3'),
      t('onboarding.mockData.recipes.salmonCrust.equipment.eq4'),
      t('onboarding.mockData.recipes.salmonCrust.equipment.eq5'),
      t('onboarding.mockData.recipes.salmonCrust.equipment.eq6'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.salmonCrust.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step1.instructions.inst4') },
          { id: 5, order: 4, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step1.instructions.inst5') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.salmonCrust.steps.step2.name'),
        instructions: [
          { id: 6, order: 0, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step2.instructions.inst1') },
          { id: 7, order: 1, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step2.instructions.inst2') },
          { id: 8, order: 2, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step2.instructions.inst3') },
          { id: 9, order: 3, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step2.instructions.inst4') },
          { id: 10, order: 4, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step2.instructions.inst5') },
          { id: 11, order: 5, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step2.instructions.inst6') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.salmonCrust.steps.step3.name'),
        instructions: [
          { id: 12, order: 0, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step3.instructions.inst1') },
          { id: 13, order: 1, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step3.instructions.inst2') },
          { id: 14, order: 2, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step3.instructions.inst3') },
          { id: 15, order: 3, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step3.instructions.inst4') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.salmonCrust.steps.step4.name'),
        instructions: [
          { id: 16, order: 0, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst1') },
          { id: 17, order: 1, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst2') },
          { id: 18, order: 2, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst3') },
          { id: 19, order: 3, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst4') },
          { id: 20, order: 4, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst5') },
          { id: 21, order: 5, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst6') },
          { id: 22, order: 6, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst7') },
          { id: 23, order: 7, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step4.instructions.inst8') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.salmonCrust.steps.step5.name'),
        instructions: [
          { id: 24, order: 0, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step5.instructions.inst1') },
          { id: 25, order: 1, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step5.instructions.inst2') },
          { id: 26, order: 2, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step5.instructions.inst3') },
          { id: 27, order: 3, instruction: t('onboarding.mockData.recipes.salmonCrust.steps.step5.instructions.inst4') },
        ],
      },
    ],
  };
}

/**
 * Recette : Boulettes de veau (ID -3)
 */
function createVealMeatballsRecipe(): Recipe {
  return {
    dish_id: -3,
    prep_time: 25,
    cook_time: 35,
    chill_time: 0,
    equipment: [
      t('onboarding.mockData.recipes.vealMeatballs.equipment.eq1'),
      t('onboarding.mockData.recipes.vealMeatballs.equipment.eq2'),
      t('onboarding.mockData.recipes.vealMeatballs.equipment.eq3'),
      t('onboarding.mockData.recipes.vealMeatballs.equipment.eq4'),
      t('onboarding.mockData.recipes.vealMeatballs.equipment.eq5'),
      t('onboarding.mockData.recipes.vealMeatballs.equipment.eq6'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.vealMeatballs.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step1.instructions.inst3') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.vealMeatballs.steps.step2.name'),
        instructions: [
          { id: 4, order: 0, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step2.instructions.inst1') },
          { id: 5, order: 1, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step2.instructions.inst2') },
          { id: 6, order: 2, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step2.instructions.inst3') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.vealMeatballs.steps.step3.name'),
        instructions: [
          { id: 7, order: 0, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step3.instructions.inst1') },
          { id: 8, order: 1, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step3.instructions.inst2') },
          { id: 9, order: 2, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step3.instructions.inst3') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.name'),
        instructions: [
          { id: 10, order: 0, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.instructions.inst1') },
          { id: 11, order: 1, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.instructions.inst2') },
          { id: 12, order: 2, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.instructions.inst3') },
          { id: 13, order: 3, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.instructions.inst4') },
          { id: 14, order: 4, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.instructions.inst5') },
          { id: 15, order: 5, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.instructions.inst6') },
          { id: 16, order: 6, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step4.instructions.inst7') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.vealMeatballs.steps.step5.name'),
        instructions: [
          { id: 17, order: 0, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step5.instructions.inst1') },
          { id: 18, order: 1, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step5.instructions.inst2') },
          { id: 19, order: 2, instruction: t('onboarding.mockData.recipes.vealMeatballs.steps.step5.instructions.inst3') },
        ],
      },
    ],
  };
}

/**
 * Recette : Galette de sarrasin (ID -4)
 */
function createBuckwheatPancakeRecipe(): Recipe {
  return {
    dish_id: -4,
    prep_time: 30,
    cook_time: 25,
    chill_time: 15,
    equipment: [
      t('onboarding.mockData.recipes.buckwheatPancake.equipment.eq1'),
      t('onboarding.mockData.recipes.buckwheatPancake.equipment.eq2'),
      t('onboarding.mockData.recipes.buckwheatPancake.equipment.eq3'),
      t('onboarding.mockData.recipes.buckwheatPancake.equipment.eq4'),
      t('onboarding.mockData.recipes.buckwheatPancake.equipment.eq5'),
      t('onboarding.mockData.recipes.buckwheatPancake.equipment.eq6'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.buckwheatPancake.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step1.instructions.inst4') },
          { id: 5, order: 4, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step1.instructions.inst5') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.buckwheatPancake.steps.step2.name'),
        instructions: [
          { id: 6, order: 0, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step2.instructions.inst1') },
          { id: 7, order: 1, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step2.instructions.inst2') },
          { id: 8, order: 2, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step2.instructions.inst3') },
          { id: 9, order: 3, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step2.instructions.inst4') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.name'),
        instructions: [
          { id: 10, order: 0, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.instructions.inst1') },
          { id: 11, order: 1, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.instructions.inst2') },
          { id: 12, order: 2, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.instructions.inst3') },
          { id: 13, order: 3, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.instructions.inst4') },
          { id: 14, order: 4, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.instructions.inst5') },
          { id: 15, order: 5, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.instructions.inst6') },
          { id: 16, order: 6, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step3.instructions.inst7') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.buckwheatPancake.steps.step4.name'),
        instructions: [
          { id: 17, order: 0, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step4.instructions.inst1') },
          { id: 18, order: 1, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step4.instructions.inst2') },
          { id: 19, order: 2, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step4.instructions.inst3') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.buckwheatPancake.steps.step5.name'),
        instructions: [
          { id: 20, order: 0, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step5.instructions.inst1') },
          { id: 21, order: 1, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step5.instructions.inst2') },
          { id: 22, order: 2, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step5.instructions.inst3') },
          { id: 23, order: 3, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step5.instructions.inst4') },
          { id: 24, order: 4, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step5.instructions.inst5') },
          { id: 25, order: 5, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step5.instructions.inst6') },
        ],
      },
      {
        id: 6,
        order: 5,
        name: t('onboarding.mockData.recipes.buckwheatPancake.steps.step6.name'),
        instructions: [
          { id: 26, order: 0, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step6.instructions.inst1') },
          { id: 27, order: 1, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step6.instructions.inst2') },
          { id: 28, order: 2, instruction: t('onboarding.mockData.recipes.buckwheatPancake.steps.step6.instructions.inst3') },
        ],
      },
    ],
  };
}

/**
 * Recette : Rôti de dinde (ID -5)
 */
function createTurkeyRoastRecipe(): Recipe {
  return {
    dish_id: -5,
    prep_time: 40,
    cook_time: 60,
    chill_time: 0,
    equipment: [
      t('onboarding.mockData.recipes.turkeyRoast.equipment.eq1'),
      t('onboarding.mockData.recipes.turkeyRoast.equipment.eq2'),
      t('onboarding.mockData.recipes.turkeyRoast.equipment.eq3'),
      t('onboarding.mockData.recipes.turkeyRoast.equipment.eq4'),
      t('onboarding.mockData.recipes.turkeyRoast.equipment.eq5'),
      t('onboarding.mockData.recipes.turkeyRoast.equipment.eq6'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.turkeyRoast.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step1.instructions.inst4') },
          { id: 5, order: 4, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step1.instructions.inst5') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.turkeyRoast.steps.step2.name'),
        instructions: [
          { id: 6, order: 0, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step2.instructions.inst1') },
          { id: 7, order: 1, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step2.instructions.inst2') },
          { id: 8, order: 2, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step2.instructions.inst3') },
          { id: 9, order: 3, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step2.instructions.inst4') },
          { id: 10, order: 4, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step2.instructions.inst5') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.name'),
        instructions: [
          { id: 11, order: 0, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst1') },
          { id: 12, order: 1, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst2') },
          { id: 13, order: 2, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst3') },
          { id: 14, order: 3, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst4') },
          { id: 15, order: 4, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst5') },
          { id: 16, order: 5, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst6') },
          { id: 17, order: 6, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst7') },
          { id: 18, order: 7, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step3.instructions.inst8') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.turkeyRoast.steps.step4.name'),
        instructions: [
          { id: 19, order: 0, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step4.instructions.inst1') },
          { id: 20, order: 1, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step4.instructions.inst2') },
          { id: 21, order: 2, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step4.instructions.inst3') },
          { id: 22, order: 3, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step4.instructions.inst4') },
          { id: 23, order: 4, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step4.instructions.inst5') },
          { id: 24, order: 5, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step4.instructions.inst6') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.turkeyRoast.steps.step5.name'),
        instructions: [
          { id: 25, order: 0, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step5.instructions.inst1') },
          { id: 26, order: 1, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step5.instructions.inst2') },
          { id: 27, order: 2, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step5.instructions.inst3') },
          { id: 28, order: 3, instruction: t('onboarding.mockData.recipes.turkeyRoast.steps.step5.instructions.inst4') },
        ],
      },
    ],
  };
}

function createCassouletRecipe(): Recipe {
  return {
    dish_id: -6,
    prep_time: 15,
    cook_time: 30,
    chill_time: 0,
    equipment: [
      t('onboarding.mockData.recipes.cassoulet.equipment.eq1'),
      t('onboarding.mockData.recipes.cassoulet.equipment.eq2'),
      t('onboarding.mockData.recipes.cassoulet.equipment.eq3'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.cassoulet.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step1.instructions.inst3') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.cassoulet.steps.step2.name'),
        instructions: [
          { id: 4, order: 0, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step2.instructions.inst1') },
          { id: 5, order: 1, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step2.instructions.inst2') },
          { id: 6, order: 2, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step2.instructions.inst3') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.cassoulet.steps.step3.name'),
        instructions: [
          { id: 7, order: 0, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step3.instructions.inst1') },
          { id: 8, order: 1, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step3.instructions.inst2') },
          { id: 9, order: 2, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step3.instructions.inst3') },
          { id: 10, order: 3, instruction: t('onboarding.mockData.recipes.cassoulet.steps.step3.instructions.inst4') },
        ],
      },
    ],
  };
}

function createRusticTartRecipe(): Recipe {
  return {
    dish_id: -7, // ID Entrée
    prep_time: 25,
    cook_time: 40,
    chill_time: 30,
    equipment: [
      t('onboarding.mockData.recipes.rusticTart.equipment.eq1'),
      t('onboarding.mockData.recipes.rusticTart.equipment.eq2'),
      t('onboarding.mockData.recipes.rusticTart.equipment.eq3'),
      t('onboarding.mockData.recipes.rusticTart.equipment.eq4'),
      t('onboarding.mockData.recipes.rusticTart.equipment.eq5'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.rusticTart.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step1.instructions.inst4') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.rusticTart.steps.step2.name'),
        instructions: [
          { id: 5, order: 0, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step2.instructions.inst1') },
          { id: 6, order: 1, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step2.instructions.inst2') },
          { id: 7, order: 2, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step2.instructions.inst3') },
          { id: 8, order: 3, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step2.instructions.inst4') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.rusticTart.steps.step3.name'),
        instructions: [
          { id: 9, order: 0, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step3.instructions.inst1') },
          { id: 10, order: 1, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step3.instructions.inst2') },
          { id: 11, order: 2, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step3.instructions.inst3') },
          { id: 12, order: 3, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step3.instructions.inst4') },
          { id: 13, order: 4, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step3.instructions.inst5') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.rusticTart.steps.step4.name'),
        instructions: [
          { id: 14, order: 0, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step4.instructions.inst1') },
          { id: 15, order: 1, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step4.instructions.inst2') },
          { id: 16, order: 2, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step4.instructions.inst3') },
          { id: 17, order: 3, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step4.instructions.inst4') },
          { id: 18, order: 4, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step4.instructions.inst5') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.rusticTart.steps.step5.name'),
        instructions: [
          { id: 19, order: 0, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step5.instructions.inst1') },
          { id: 20, order: 1, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step5.instructions.inst2') },
          { id: 21, order: 2, instruction: t('onboarding.mockData.recipes.rusticTart.steps.step5.instructions.inst3') },
        ],
      },
    ],
  };
}

function createScallopsRecipe(): Recipe {
  return {
    dish_id: -8, // ID Entrée
    prep_time: 30,
    cook_time: 35,
    chill_time: 0,
    equipment: [
      t('onboarding.mockData.recipes.scallops.equipment.eq1'),
      t('onboarding.mockData.recipes.scallops.equipment.eq2'),
      t('onboarding.mockData.recipes.scallops.equipment.eq3'),
      t('onboarding.mockData.recipes.scallops.equipment.eq4'),
      t('onboarding.mockData.recipes.scallops.equipment.eq5'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.scallops.steps.step1.name'),
        instructions: [
          { id: 52, order: 0, instruction: t('onboarding.mockData.recipes.scallops.steps.step1.instructions.inst1') },
          { id: 53, order: 1, instruction: t('onboarding.mockData.recipes.scallops.steps.step1.instructions.inst2') },
          { id: 54, order: 2, instruction: t('onboarding.mockData.recipes.scallops.steps.step1.instructions.inst3') },
          { id: 55, order: 3, instruction: t('onboarding.mockData.recipes.scallops.steps.step1.instructions.inst4') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.scallops.steps.step2.name'),
        instructions: [
          { id: 56, order: 0, instruction: t('onboarding.mockData.recipes.scallops.steps.step2.instructions.inst1') },
          { id: 57, order: 1, instruction: t('onboarding.mockData.recipes.scallops.steps.step2.instructions.inst2') },
          { id: 58, order: 2, instruction: t('onboarding.mockData.recipes.scallops.steps.step2.instructions.inst3') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.scallops.steps.step3.name'),
        instructions: [
          { id: 59, order: 0, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst1') },
          { id: 60, order: 1, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst2') },
          { id: 61, order: 2, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst3') },
          { id: 62, order: 3, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst4') },
          { id: 63, order: 4, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst5') },
          { id: 64, order: 5, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst6') },
          { id: 65, order: 6, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst7') },
          { id: 66, order: 7, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst8') },
          { id: 67, order: 8, instruction: t('onboarding.mockData.recipes.scallops.steps.step3.instructions.inst9') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.scallops.steps.step4.name'),
        instructions: [
          { id: 68, order: 0, instruction: t('onboarding.mockData.recipes.scallops.steps.step4.instructions.inst1') },
          { id: 69, order: 1, instruction: t('onboarding.mockData.recipes.scallops.steps.step4.instructions.inst2') },
          { id: 70, order: 2, instruction: t('onboarding.mockData.recipes.scallops.steps.step4.instructions.inst3') },
          { id: 71, order: 3, instruction: t('onboarding.mockData.recipes.scallops.steps.step4.instructions.inst4') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.scallops.steps.step5.name'),
        instructions: [
          { id: 72, order: 0, instruction: t('onboarding.mockData.recipes.scallops.steps.step5.instructions.inst1') },
          { id: 73, order: 1, instruction: t('onboarding.mockData.recipes.scallops.steps.step5.instructions.inst2') },
          { id: 74, order: 2, instruction: t('onboarding.mockData.recipes.scallops.steps.step5.instructions.inst3') },
          { id: 75, order: 3, instruction: t('onboarding.mockData.recipes.scallops.steps.step5.instructions.inst4') },
        ],
      },
    ],
  };
}

function createButternutLasagnaRecipe(): Recipe {
  return {
    dish_id: -9,
    prep_time: 30,
    cook_time: 45,
    chill_time: 0,
    equipment: [
      t('onboarding.mockData.recipes.butternutLasagna.equipment.eq1'),
      t('onboarding.mockData.recipes.butternutLasagna.equipment.eq2'),
      t('onboarding.mockData.recipes.butternutLasagna.equipment.eq3'),
      t('onboarding.mockData.recipes.butternutLasagna.equipment.eq4'),
      t('onboarding.mockData.recipes.butternutLasagna.equipment.eq5'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.butternutLasagna.steps.step1.name'),
        instructions: [
          { id: 76, order: 0, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step1.instructions.inst1') },
          { id: 77, order: 1, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step1.instructions.inst2') },
          { id: 78, order: 2, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step1.instructions.inst3') },
          { id: 79, order: 3, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step1.instructions.inst4') },
          { id: 80, order: 4, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step1.instructions.inst5') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.butternutLasagna.steps.step2.name'),
        instructions: [
          { id: 81, order: 0, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step2.instructions.inst1') },
          { id: 82, order: 1, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step2.instructions.inst2') },
          { id: 83, order: 2, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step2.instructions.inst3') },
          { id: 84, order: 3, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step2.instructions.inst4') },
          { id: 85, order: 4, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step2.instructions.inst5') },
          { id: 86, order: 5, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step2.instructions.inst6') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.butternutLasagna.steps.step3.name'),
        instructions: [
          { id: 87, order: 0, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step3.instructions.inst1') },
          { id: 88, order: 1, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step3.instructions.inst2') },
          { id: 89, order: 2, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step3.instructions.inst3') },
          { id: 90, order: 3, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step3.instructions.inst4') },
          { id: 91, order: 4, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step3.instructions.inst5') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.butternutLasagna.steps.step4.name'),
        instructions: [
          { id: 92, order: 0, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step4.instructions.inst1') },
          { id: 93, order: 1, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step4.instructions.inst2') },
          { id: 94, order: 2, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step4.instructions.inst3') },
          { id: 95, order: 3, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step4.instructions.inst4') },
          { id: 96, order: 4, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step4.instructions.inst5') },
          { id: 97, order: 5, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step4.instructions.inst6') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.butternutLasagna.steps.step5.name'),
        instructions: [
          { id: 98, order: 0, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step5.instructions.inst1') },
          { id: 99, order: 1, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step5.instructions.inst2') },
          { id: 100, order: 2, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step5.instructions.inst3') },
          { id: 101, order: 3, instruction: t('onboarding.mockData.recipes.butternutLasagna.steps.step5.instructions.inst4') },
        ],
      },
    ],
  };
}

function createRaviolesGratinRecipe(): Recipe {
  return {
    dish_id: -10, // ID Entrée
    prep_time: 20,
    cook_time: 30,
    chill_time: 0,
    equipment: [
      t('onboarding.mockData.recipes.raviolesGratin.equipment.eq1'),
      t('onboarding.mockData.recipes.raviolesGratin.equipment.eq2'),
      t('onboarding.mockData.recipes.raviolesGratin.equipment.eq3'),
      t('onboarding.mockData.recipes.raviolesGratin.equipment.eq4'),
      t('onboarding.mockData.recipes.raviolesGratin.equipment.eq5'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.raviolesGratin.steps.step1.name'),
        instructions: [
          { id: 102, order: 0, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step1.instructions.inst1') },
          { id: 103, order: 1, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step1.instructions.inst2') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.raviolesGratin.steps.step2.name'),
        instructions: [
          { id: 104, order: 0, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step2.instructions.inst1') },
          { id: 105, order: 1, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step2.instructions.inst2') },
          { id: 106, order: 2, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step2.instructions.inst3') },
          { id: 107, order: 3, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step2.instructions.inst4') },
          { id: 108, order: 4, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step2.instructions.inst5') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.raviolesGratin.steps.step3.name'),
        instructions: [
          { id: 109, order: 0, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step3.instructions.inst1') },
          { id: 110, order: 1, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step3.instructions.inst2') },
          { id: 111, order: 2, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step3.instructions.inst3') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.raviolesGratin.steps.step4.name'),
        instructions: [
          { id: 112, order: 0, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step4.instructions.inst1') },
          { id: 113, order: 1, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step4.instructions.inst2') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.name'),
        instructions: [
          { id: 114, order: 0, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst1') },
          { id: 115, order: 1, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst2') },
          { id: 116, order: 2, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst3') },
          { id: 117, order: 3, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst4') },
          { id: 118, order: 4, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst5') },
          { id: 119, order: 5, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst6') },
          { id: 120, order: 6, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst7') },
          { id: 121, order: 7, instruction: t('onboarding.mockData.recipes.raviolesGratin.steps.step5.instructions.inst8') },
        ],
      },
    ],
  };
}

function createClementineClafoutisRecipe(): Recipe {
  return {
    dish_id: -11,
    prep_time: 15,
    cook_time: 25,
    chill_time: 10,
    equipment: [
      t('onboarding.mockData.recipes.clementineClafoutis.equipment.eq1'),
      t('onboarding.mockData.recipes.clementineClafoutis.equipment.eq2'),
      t('onboarding.mockData.recipes.clementineClafoutis.equipment.eq3'),
      t('onboarding.mockData.recipes.clementineClafoutis.equipment.eq4'),
      t('onboarding.mockData.recipes.clementineClafoutis.equipment.eq5'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.clementineClafoutis.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step1.instructions.inst3') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.clementineClafoutis.steps.step2.name'),
        instructions: [
          { id: 4, order: 0, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step2.instructions.inst1') },
          { id: 5, order: 1, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step2.instructions.inst2') },
          { id: 6, order: 2, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step2.instructions.inst3') },
          { id: 7, order: 3, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step2.instructions.inst4') },
          { id: 8, order: 4, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step2.instructions.inst5') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.clementineClafoutis.steps.step3.name'),
        instructions: [
          { id: 9, order: 0, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step3.instructions.inst1') },
          { id: 10, order: 1, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step3.instructions.inst2') },
          { id: 11, order: 2, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step3.instructions.inst3') },
          { id: 12, order: 3, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step3.instructions.inst4') },
          { id: 13, order: 4, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step3.instructions.inst5') },
          { id: 14, order: 5, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step3.instructions.inst6') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.clementineClafoutis.steps.step4.name'),
        instructions: [
          { id: 15, order: 0, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step4.instructions.inst1') },
          { id: 16, order: 1, instruction: t('onboarding.mockData.recipes.clementineClafoutis.steps.step4.instructions.inst2') },
        ],
      },
    ],
  };
}

function createWhiteChocolateMousseRecipe(): Recipe {
  return {
    dish_id: -12,
    prep_time: 25,
    cook_time: 15,
    chill_time: 120,
    equipment: [
      t('onboarding.mockData.recipes.whiteChocMousse.equipment.eq1'),
      t('onboarding.mockData.recipes.whiteChocMousse.equipment.eq2'),
      t('onboarding.mockData.recipes.whiteChocMousse.equipment.eq3'),
      t('onboarding.mockData.recipes.whiteChocMousse.equipment.eq4'),
      t('onboarding.mockData.recipes.whiteChocMousse.equipment.eq5'),
      t('onboarding.mockData.recipes.whiteChocMousse.equipment.eq6'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.whiteChocMousse.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step1.instructions.inst4') },
          { id: 5, order: 4, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step1.instructions.inst5') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.name'),
        instructions: [
          { id: 6, order: 0, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst1') },
          { id: 7, order: 1, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst2') },
          { id: 8, order: 2, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst3') },
          { id: 9, order: 3, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst4') },
          { id: 10, order: 4, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst5') },
          { id: 11, order: 5, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst6') },
          { id: 12, order: 6, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst7') },
          { id: 13, order: 7, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst8') },
          { id: 14, order: 8, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step2.instructions.inst9') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.whiteChocMousse.steps.step3.name'),
        instructions: [
          { id: 15, order: 0, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step3.instructions.inst1') },
          { id: 16, order: 1, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step3.instructions.inst2') },
          { id: 17, order: 2, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step3.instructions.inst3') },
          { id: 18, order: 3, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step3.instructions.inst4') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.whiteChocMousse.steps.step4.name'),
        instructions: [
          { id: 19, order: 0, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step4.instructions.inst1') },
          { id: 20, order: 1, instruction: t('onboarding.mockData.recipes.whiteChocMousse.steps.step4.instructions.inst2') },
        ],
      },
    ],
  };
}

function createCardamomCremeBruleeRecipe(): Recipe {
  return {
    dish_id: -13,
    prep_time: 25,
    cook_time: 35,
    chill_time: 120,
    equipment: [
      t('onboarding.mockData.recipes.cardamomCremeBrulee.equipment.eq1'),
      t('onboarding.mockData.recipes.cardamomCremeBrulee.equipment.eq2'),
      t('onboarding.mockData.recipes.cardamomCremeBrulee.equipment.eq3'),
      t('onboarding.mockData.recipes.cardamomCremeBrulee.equipment.eq4'),
      t('onboarding.mockData.recipes.cardamomCremeBrulee.equipment.eq5'),
      t('onboarding.mockData.recipes.cardamomCremeBrulee.equipment.eq6'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.instructions.inst4') },
          { id: 5, order: 4, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.instructions.inst5') },
          { id: 6, order: 5, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.instructions.inst6') },
          { id: 7, order: 6, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step1.instructions.inst7') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step2.name'),
        instructions: [
          { id: 8, order: 0, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step2.instructions.inst1') },
          { id: 9, order: 1, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step2.instructions.inst2') },
          { id: 10, order: 2, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step2.instructions.inst3') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step3.name'),
        instructions: [
          { id: 11, order: 0, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step3.instructions.inst1') },
          { id: 12, order: 1, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step3.instructions.inst2') },
          { id: 13, order: 2, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step3.instructions.inst3') },
          { id: 14, order: 3, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step3.instructions.inst4') },
          { id: 15, order: 4, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step3.instructions.inst5') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step4.name'),
        instructions: [
          { id: 16, order: 0, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step4.instructions.inst1') },
          { id: 17, order: 1, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step4.instructions.inst2') },
          { id: 18, order: 2, instruction: t('onboarding.mockData.recipes.cardamomCremeBrulee.steps.step4.instructions.inst3') },
        ],
      },
    ],
  };
}

function createFloatingIslandRecipe(): Recipe {
  return {
    dish_id: -14,
    prep_time: 25,
    cook_time: 20,
    chill_time: 30,
    equipment: [
      t('onboarding.mockData.recipes.floatingIsland.equipment.eq1'),
      t('onboarding.mockData.recipes.floatingIsland.equipment.eq2'),
      t('onboarding.mockData.recipes.floatingIsland.equipment.eq3'),
      t('onboarding.mockData.recipes.floatingIsland.equipment.eq4'),
      t('onboarding.mockData.recipes.floatingIsland.equipment.eq5'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.floatingIsland.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst3') },
          { id: 4, order: 3, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst4') },
          { id: 5, order: 4, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst5') },
          { id: 6, order: 5, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst6') },
          { id: 7, order: 6, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst7') },
          { id: 8, order: 7, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step1.instructions.inst8') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.floatingIsland.steps.step2.name'),
        instructions: [
          { id: 9, order: 0, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step2.instructions.inst1') },
          { id: 10, order: 1, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step2.instructions.inst2') },
          { id: 11, order: 2, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step2.instructions.inst3') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.floatingIsland.steps.step3.name'),
        instructions: [
          { id: 12, order: 0, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step3.instructions.inst1') },
          { id: 13, order: 1, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step3.instructions.inst2') },
          { id: 14, order: 2, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step3.instructions.inst3') },
          { id: 15, order: 3, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step3.instructions.inst4') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.floatingIsland.steps.step4.name'),
        instructions: [
          { id: 16, order: 0, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step4.instructions.inst1') },
          { id: 17, order: 1, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step4.instructions.inst2') },
          { id: 18, order: 2, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step4.instructions.inst3') },
          { id: 19, order: 3, instruction: t('onboarding.mockData.recipes.floatingIsland.steps.step4.instructions.inst4') },
        ],
      },
    ],
  };
}

function createHazelnutFinancierRecipe(): Recipe {
  return {
    dish_id: -15,
    prep_time: 25,
    cook_time: 15,
    chill_time: 20,
    equipment: [
      t('onboarding.mockData.recipes.hazelnutFinancier.equipment.eq1'),
      t('onboarding.mockData.recipes.hazelnutFinancier.equipment.eq2'),
      t('onboarding.mockData.recipes.hazelnutFinancier.equipment.eq3'),
      t('onboarding.mockData.recipes.hazelnutFinancier.equipment.eq4'),
      t('onboarding.mockData.recipes.hazelnutFinancier.equipment.eq5'),
      t('onboarding.mockData.recipes.hazelnutFinancier.equipment.eq6'),
      t('onboarding.mockData.recipes.hazelnutFinancier.equipment.eq7'),
    ],
    steps: [
      {
        id: 1,
        order: 0,
        name: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step1.name'),
        instructions: [
          { id: 1, order: 0, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step1.instructions.inst1') },
          { id: 2, order: 1, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step1.instructions.inst2') },
          { id: 3, order: 2, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step1.instructions.inst3') },
        ],
      },
      {
        id: 2,
        order: 1,
        name: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step2.name'),
        instructions: [
          { id: 4, order: 0, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step2.instructions.inst1') },
          { id: 5, order: 1, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step2.instructions.inst2') },
          { id: 6, order: 2, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step2.instructions.inst3') },
        ],
      },
      {
        id: 3,
        order: 2,
        name: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step3.name'),
        instructions: [
          { id: 7, order: 0, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step3.instructions.inst1') },
          { id: 8, order: 1, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step3.instructions.inst2') },
          { id: 9, order: 2, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step3.instructions.inst3') },
          { id: 10, order: 3, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step3.instructions.inst4') },
        ],
      },
      {
        id: 4,
        order: 3,
        name: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step4.name'),
        instructions: [
          { id: 11, order: 0, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step4.instructions.inst1') },
          { id: 12, order: 1, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step4.instructions.inst2') },
          { id: 13, order: 2, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step4.instructions.inst3') },
          { id: 14, order: 3, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step4.instructions.inst4') },
        ],
      },
      {
        id: 5,
        order: 4,
        name: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step5.name'),
        instructions: [
          { id: 15, order: 0, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step5.instructions.inst1') },
          { id: 16, order: 1, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step5.instructions.inst2') },
          { id: 17, order: 2, instruction: t('onboarding.mockData.recipes.hazelnutFinancier.steps.step5.instructions.inst3') },
        ],
      },
    ],
  };
}

// Map des factory functions pour recettes par ID
export const recipeFactories: Record<number, () => Recipe> = {
  [-1]: createParmentierRecipe,
  [-2]: createSalmonCrustRecipe,
  [-3]: createVealMeatballsRecipe,
  [-4]: createBuckwheatPancakeRecipe,
  [-5]: createTurkeyRoastRecipe,

  [-6]: createCassouletRecipe,
  [-7]: createRusticTartRecipe,
  [-8]: createScallopsRecipe,
  [-9]: createButternutLasagnaRecipe,
  [-10]: createRaviolesGratinRecipe,

  [-11]: createClementineClafoutisRecipe,
  [-12]: createWhiteChocolateMousseRecipe,
  [-13]: createCardamomCremeBruleeRecipe,
  [-14]: createFloatingIslandRecipe,
  [-15]: createHazelnutFinancierRecipe,
};

export { createParmentierRecipe };
